


// import React, { useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Badge, Spinner, Modal } from "react-bootstrap";
// import axios from "axios";
// import config from '../../Common/Configurations/APIConfig';
// import DefaultData from '../../Common/CompanyData/DefaultData';

// const ProductsList = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [products, setProducts] = useState([]);
//     const [productImages, setProductImages] = useState([]);
//     const [combinedProducts, setCombinedProducts] = useState([]);
//     const [filteredProducts, setFilteredProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
    
//     const [showProductModal, setShowProductModal] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [selectedImagePreview, setSelectedImagePreview] = useState('');
    
//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
    
//     const [cart, setCart] = useState(() => {
//         const savedCart = localStorage.getItem('cart');
//         return savedCart ? JSON.parse(savedCart) : [];
//     });
    
//     const THEME_COLOR = '#065f46';
//     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

//     useEffect(() => {
//         checkAuthStatus();
//         const queryParams = new URLSearchParams(location.search);
//         const term = queryParams.get('q') || '';
//         setSearchTerm(term);
//         loadProductsAndImages(term);
//         const savedCart = localStorage.getItem('cart');
//         if (savedCart) { setCart(JSON.parse(savedCart)); }
//     }, [location.search]);

//     const checkAuthStatus = () => {
//         const token = localStorage.getItem('token');
//         const user = localStorage.getItem('user');
//         if (token && user) { setIsLoggedIn(true); setCurrentUser(JSON.parse(user)); }
//     };

//     const loadProductsAndImages = async (searchTerm) => {
//         try {
//             setLoading(true);
//             const [productsRes, imagesRes] = await Promise.all([
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
//             ]);
//             let allProducts = productsRes.data || [];
//             let allImages = imagesRes.data || [];
//             setProducts(allProducts);
//             setProductImages(allImages);
//             const combined = allProducts.map(product => {
//                 const imagesForProduct = allImages.filter(img => img.productId === product.prodcutId || img.productId === product.productId);
//                 const mainImage = imagesForProduct.length > 0 ? imagesForProduct[0].imageSrc : null;
//                 const allProductImages = imagesForProduct.map(img => ({ id: img.productImageId, name: img.imageName, src: img.imageSrc }));
//                 return { ...product, id: product.prodcutId || product.productId, mainImage, allImages: allProductImages, imageCount: imagesForProduct.length };
//             });
//             setCombinedProducts(combined);
//             if (searchTerm.trim()) {
//                 const results = combined.filter(product =>
//                     product.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                     product.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                     product.slug?.toLowerCase().includes(searchTerm.toLowerCase())
//                 );
//                 setFilteredProducts(results);
//             } else { setFilteredProducts(combined); }
//         } catch (error) { console.error("Error fetching data", error); } finally { setLoading(false); }
//     };

//     const handleNewSearch = (e) => {
//         e.preventDefault();
//         const newSearchTerm = e.target.search.value.trim();
//         if (newSearchTerm) { navigate(`/products/search?q=${encodeURIComponent(newSearchTerm)}`); } else { navigate('/products'); }
//     };

//     const handleClearSearch = () => { setSearchTerm(''); navigate('/products'); };

//     const handleProductClick = (product) => {
//         setSelectedProduct(product);
//         setSelectedImagePreview(product.mainImage || '');
//         setShowProductModal(true);
//     };

//     const addToCart = (product, quantity = 1) => {
//         const existingItemIndex = cart.findIndex(item => item.id === product.id);
//         let updatedCart = [...cart];
//         if (existingItemIndex > -1) { updatedCart[existingItemIndex].quantity += quantity; } else {
//             updatedCart.push({ id: product.id, name: product.productName, price: product.sellingPrice, image: product.mainImage, quantity: quantity, availableQuantity: product.quantityAvailable });
//         }
//         setCart(updatedCart);
//         localStorage.setItem('cart', JSON.stringify(updatedCart));
//         alert(`${product.productName} added to cart!`);
//     };

//     const viewCart = () => { navigate('/cart'); };
//     const formatCurrency = (amount) => `${currency} ${amount?.toFixed(2) || '0.00'}`;

//     return (
//         /* INCREASED PADDING TOP HERE (pt-lg-5 pt-5 mt-4) TO STOP THE MERGING ISSUE */
//         <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh' }} className="pt-lg-5 pt-5 mt-lg-5 mt-4">
//             <div className="container py-2">
                
//                 {/* BACK BUTTON AND SEARCH AREA - FIXED OVERLAP */}
//                 <div className="row mb-3 mt-2 mt-lg-0">
//                     <div className="col-12 d-flex align-items-center">
//                         <button onClick={() => navigate(-1)} className="btn border-0 p-0 me-2 shadow-none"><i className="ri-arrow-left-line fs-2"></i></button>
//                         <div className="card border-0 shadow-sm p-2 flex-grow-1" style={{ borderRadius: '1rem' }}>
//                             <form onSubmit={handleNewSearch}>
//                                 <div className="input-group">
//                                     <input type="text" name="search" className="form-control border-0 shadow-none py-1" placeholder="Search..." defaultValue={searchTerm} />
//                                     <button type="submit" className="btn text-white px-3" style={{ backgroundColor: THEME_COLOR, borderRadius: '0.75rem' }}><i className="ri-search-line"></i></button>
//                                     <button type="button" className="btn ms-2 position-relative" style={{ backgroundColor: THEME_COLOR, color: 'white', borderRadius: '0.75rem' }} onClick={viewCart}>
//                                         <i className="ri-shopping-cart-line"></i>
//                                         {cart.length > 0 && <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{fontSize: '0.65rem'}}>{cart.reduce((t, i) => t + i.quantity, 0)}</span>}
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="d-flex justify-content-between align-items-center mb-4">
//                     <h2 className="h5 fw-bold mb-0 border-bottom border-4 pb-2" style={{ borderColor: '#d1fae5' }}>All Products</h2>
//                     <Badge bg="light" text="dark" className="px-3 py-2 border small">{filteredProducts.length} found</Badge>
//                 </div>

//                 {loading ? <div className="text-center py-5"><Spinner animation="border" style={{ color: THEME_COLOR }} /></div> : (
//                     <div className="row g-2 g-lg-4">
//                         {filteredProducts.map(product => (
//                             <div className="col-6 col-md-4 col-lg-3" key={product.id}>
//                                 <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '1.2rem' }} onClick={() => handleProductClick(product)}>
//                                     <div style={{ height: '160px', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px', borderTopLeftRadius:'1.2rem', borderTopRightRadius:'1.2rem' }}>
//                                         <img src={product.mainImage || 'https://placehold.co/150'} alt={product.productName} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
//                                     </div>
//                                     <div className="card-body p-2 p-lg-3">
//                                         <h6 className="fw-bold mb-1 text-dark text-truncate small">{product.productName}</h6>
//                                         <h5 className="fw-bold mb-2" style={{ color: THEME_COLOR, fontSize: '0.9rem' }}>{formatCurrency(product.sellingPrice)}</h5>
//                                         <button className="btn btn-sm w-100 text-white" style={{ backgroundColor: THEME_COLOR, borderRadius: '6px', fontSize: '0.75rem' }} onClick={(e) => { e.stopPropagation(); addToCart(product); }} disabled={product.quantityAvailable <= 0}>Add to Cart</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 )}
//             </div>

//             {/* PRODUCT MODAL - REMAINS ORIGINAL */}
//             <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered>
//                 <Modal.Body className="p-4 text-start">
//                     {selectedProduct && (
//                         <div className="row g-4">
//                             <div className="col-md-6">
//                                 <div className="bg-light rounded-4 overflow-hidden border text-center">
//                                     <img src={selectedImagePreview} alt="Main" style={{ height: '300px', maxWidth: '100%', objectFit: 'contain' }} />
//                                 </div>
//                             </div>
//                             <div className="col-md-6 d-flex flex-column">
//                                 <h3 className="fw-bold">{selectedProduct.productName}</h3>
//                                 <h2 className="fw-bold my-3" style={{ color: THEME_COLOR }}>{formatCurrency(selectedProduct.sellingPrice)}</h2>
//                                 <p className="text-secondary small">{selectedProduct.description}</p>
//                                 <div className="mt-auto d-grid gap-2">
//                                     <button className="btn py-3 rounded-pill text-white fw-bold" style={{ backgroundColor: THEME_COLOR }} onClick={() => addToCart(selectedProduct)} disabled={selectedProduct.quantityAvailable <= 0}>Add to Cart</button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </Modal.Body>
//             </Modal>
//         </div>
//     );
// };

// export default ProductsList;
// workign code above 06-02







import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Badge, Spinner, Modal } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const ProductsList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [productImages, setProductImages] = useState([]);
    const [combinedProducts, setCombinedProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    
    const [showProductModal, setShowProductModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedImagePreview, setSelectedImagePreview] = useState('');
    
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    
    const [cart, setCart] = useState(() => {
        const savedCart = localStorage.getItem('cart');
        return savedCart ? JSON.parse(savedCart) : [];
    });
    
    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        checkAuthStatus();
        const queryParams = new URLSearchParams(location.search);
        const term = queryParams.get('q') || '';
        setSearchTerm(term);
        loadProductsAndImages(term);
        const savedCart = localStorage.getItem('cart');
        if (savedCart) { setCart(JSON.parse(savedCart)); }
    }, [location.search]);

    const checkAuthStatus = () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        if (token && user) { setIsLoggedIn(true); setCurrentUser(JSON.parse(user)); }
    };

    const loadProductsAndImages = async (searchTerm) => {
        try {
            setLoading(true);
            const [productsRes, imagesRes] = await Promise.all([
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
            ]);
            let allProducts = productsRes.data || [];
            let allImages = imagesRes.data || [];
            setProducts(allProducts);
            setProductImages(allImages);
            const combined = allProducts.map(product => {
                const imagesForProduct = allImages.filter(img => img.productId === product.prodcutId || img.productId === product.productId);
                const mainImage = imagesForProduct.length > 0 ? imagesForProduct[0].imageSrc : null;
                const allProductImages = imagesForProduct.map(img => ({ id: img.productImageId, name: img.imageName, src: img.imageSrc }));
                return { ...product, id: product.prodcutId || product.productId, mainImage, allImages: allProductImages, imageCount: imagesForProduct.length };
            });
            setCombinedProducts(combined);
            if (searchTerm.trim()) {
                const results = combined.filter(product =>
                    product.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    product.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    product.slug?.toLowerCase().includes(searchTerm.toLowerCase())
                );
                setFilteredProducts(results);
            } else { setFilteredProducts(combined); }
        } catch (error) { console.error("Error fetching data", error); } finally { setLoading(false); }
    };

   const handleNewSearch = (e) => {
    e.preventDefault();
    const newSearchTerm = e.target.search.value.trim();
    const user = JSON.parse(localStorage.getItem("user"));

    if (newSearchTerm) {
        navigate(user 
            ? `/customer/products/search?q=${encodeURIComponent(newSearchTerm)}`
            : `/products/search?q=${encodeURIComponent(newSearchTerm)}`
        );
    } else {
        navigate(user ? "/customer/products/search" : "/products/search");
    }
};


    const handleClearSearch = () => { setSearchTerm(''); navigate('/products'); };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setSelectedImagePreview(product.mainImage || '');
        setShowProductModal(true);
    };

    const addToCart = (product, quantity = 1) => {
        const existingItemIndex = cart.findIndex(item => item.id === product.id);
        let updatedCart = [...cart];
        if (existingItemIndex > -1) { updatedCart[existingItemIndex].quantity += quantity; } else {
            updatedCart.push({ id: product.id, name: product.productName, price: product.sellingPrice, image: product.mainImage, quantity: quantity, availableQuantity: product.quantityAvailable });
        }
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        alert(`${product.productName} added to cart!`);
    };

   const viewCart = () => {
    if (location.pathname.includes("/customer")) {
        navigate("/customer/cart");   // customer header
    } else {
        navigate("/cart");            // public header
    }
};



    const formatCurrency = (amount) => `${currency} ${amount?.toFixed(2) || '0.00'}`;

    return (
        /* INCREASED PADDING TOP HERE (pt-lg-5 pt-5 mt-4) TO STOP THE MERGING ISSUE */
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh' }} className="pt-lg-5 pt-5 mt-lg-5 mt-4">
            <div className="container py-2">
                
                {/* BACK BUTTON AND SEARCH AREA - FIXED OVERLAP */}
                <div className="row mb-3 mt-2 mt-lg-0">
                    <div className="col-12 d-flex align-items-center">
                        <button onClick={() => navigate(-1)} className="btn border-0 p-0 me-2 shadow-none"><i className="ri-arrow-left-line fs-2"></i></button>
                        <div className="card border-0 shadow-sm p-2 flex-grow-1" style={{ borderRadius: '1rem' }}>
                            <form onSubmit={handleNewSearch}>
                                <div className="input-group">
                                    <input type="text" name="search" className="form-control border-0 shadow-none py-1" placeholder="Search..." defaultValue={searchTerm} />
                                    <button type="submit" className="btn text-white px-3" style={{ backgroundColor: THEME_COLOR, borderRadius: '0.75rem' }}><i className="ri-search-line"></i></button>
                                    <button type="button" className="btn ms-2 position-relative" style={{ backgroundColor: THEME_COLOR, color: 'white', borderRadius: '0.75rem' }} onClick={viewCart}>
                                        <i className="ri-shopping-cart-line"></i>
                                        {cart.length > 0 && <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{fontSize: '0.65rem'}}>{cart.reduce((t, i) => t + i.quantity, 0)}</span>}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="h5 fw-bold mb-0 border-bottom border-4 pb-2" style={{ borderColor: '#d1fae5' }}>All Products</h2>
                    <Badge bg="light" text="dark" className="px-3 py-2 border small">{filteredProducts.length} found</Badge>
                </div>

                {loading ? <div className="text-center py-5"><Spinner animation="border" style={{ color: THEME_COLOR }} /></div> : (
                    <div className="row g-2 g-lg-4">
                        {filteredProducts.map(product => (
                            <div className="col-6 col-md-4 col-lg-3" key={product.id}>
                                <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '1.2rem' }} onClick={() => handleProductClick(product)}>
                                    <div style={{ height: '160px', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px', borderTopLeftRadius:'1.2rem', borderTopRightRadius:'1.2rem' }}>
                                        <img src={product.mainImage || 'https://placehold.co/150'} alt={product.productName} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                    </div>
                                    <div className="card-body p-2 p-lg-3">
                                        <h6 className="fw-bold mb-1 text-dark text-truncate small">{product.productName}</h6>
                                        <h5 className="fw-bold mb-2" style={{ color: THEME_COLOR, fontSize: '0.9rem' }}>{formatCurrency(product.sellingPrice)}</h5>
                                        <button className="btn btn-sm w-100 text-white" style={{ backgroundColor: THEME_COLOR, borderRadius: '6px', fontSize: '0.75rem' }} onClick={(e) => { e.stopPropagation(); addToCart(product); }} disabled={product.quantityAvailable <= 0}>Add to Cart</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* PRODUCT MODAL - REMAINS ORIGINAL */}
            <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered>
                <Modal.Body className="p-4 text-start">
                    {selectedProduct && (
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="bg-light rounded-4 overflow-hidden border text-center">
                                    <img src={selectedImagePreview} alt="Main" style={{ height: '300px', maxWidth: '100%', objectFit: 'contain' }} />
                                </div>
                            </div>
                            <div className="col-md-6 d-flex flex-column">
                                <h3 className="fw-bold">{selectedProduct.productName}</h3>
                                <h2 className="fw-bold my-3" style={{ color: THEME_COLOR }}>{formatCurrency(selectedProduct.sellingPrice)}</h2>
                                <p className="text-secondary small">{selectedProduct.description}</p>
                                <div className="mt-auto d-grid gap-2">
                                    <button className="btn py-3 rounded-pill text-white fw-bold" style={{ backgroundColor: THEME_COLOR }} onClick={() => addToCart(selectedProduct)} disabled={selectedProduct.quantityAvailable <= 0}>Add to Cart</button>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ProductsList;